import { roleNames } from './roles'

interface AccessSubject {
  role?: null | string | { name: string }
  roles?: null | readonly (string | { name: string })[]
}

export const normalizeName = (name: string): string => {
  return name.trim().toLowerCase().replace(/\s+/g, '-')
}

export const isSuperAdmin = (subject: AccessSubject | null): boolean => {
  const normalized = normalizeName(roleNames.superAdmin)
  const fromRoles = subject?.roles?.some(role => normalizeRole(role) === normalized) ?? false
  const fromRole = subject?.role ? normalizeRole(subject.role) === normalized : false

  return fromRoles || fromRole
}

const isStringRole = (role: string | { name: string }): role is string => role === String(role)

export const normalizeRole = (role: string | { name: string }): string => {
  return normalizeName(isStringRole(role) ? role : role.name)
}
